import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

import pt from 'vuetify/es5/locale/pt';

export default new Vuetify({
  theme: {
    themes: {
      light: {
        background: colors.grey.lighten3
      }
    }
  },
  lang: {
    locales: { pt },
    current: 'pt'
  }
});
